import React from 'react';
import { useUnscrollableBody } from '../../../common/utils/windowDimensions';

const WrapperModalPortal = ({ children, unscrollable = true }) => {
    useUnscrollableBody(children, 'WrapperModalPortal', null, unscrollable);
    return <>{children}</>;
};

export default WrapperModalPortal;
